let size = 0;
let hasWalls = true;
function clearCanvases() {
  // Select ALL <canvas> elements inside uniformCanvases and the hidden div
  const canvases = document.querySelectorAll(
    '#tent-canvases canvas, [style*="display: none"] canvas'
  );

  canvases.forEach(canvas => {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  });
}
function initializeAllCanvases() {
    clearCanvases();
    if(itType){
        if(`${itDescript}`.includes('10x20')){
            initialize10x20PeakCanvas("FrontPeakCanvas", document.getElementById('FrontPeakCanvas').getContext('2d'));
            initialize10x20ValanceCanvas(document.getElementById('FrontValanceCanvas').getContext('2d'));
        
            initialize10x20PeakCanvas("BackPeakCanvas", document.getElementById('BackPeakCanvas').getContext('2d'));
            initialize10x20ValanceCanvas(document.getElementById('BackValanceCanvas').getContext('2d'));
            initialize10x20WallCanvas(document.getElementById('BackWallCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("RightPeakCanvas", document.getElementById('RightPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('RightValanceCanvas').getContext('2d'));
            initialize10x10WallCanvas(document.getElementById('RightWallCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("LeftPeakCanvas", document.getElementById('LeftPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('LeftValanceCanvas').getContext('2d'));
            initialize10x10WallCanvas(document.getElementById('LeftWallCanvas').getContext('2d'));

            document.getElementById('FrontPeakCanvas').style.marginLeft = '-60px';
            document.getElementById('FrontValanceCanvas').style.marginLeft = '-60px';
            document.getElementById('BackPeakCanvas').style.marginLeft = '-60px';
            document.getElementById('BackValanceCanvas').style.marginLeft = '-60px';
            document.getElementById('BackWallCanvas').style.marginLeft = '-60px';
            document.getElementById('ValanceLogo').style.right = '5px';
            size = 20;
            
        }
        else if(`${itDescript}`.includes('10x15')){
            initialize10x15PeakCanvas("FrontPeakCanvas", document.getElementById('FrontPeakCanvas').getContext('2d'));
            initialize10x15ValanceCanvas(document.getElementById('FrontValanceCanvas').getContext('2d'));
        
            initialize10x15PeakCanvas("BackPeakCanvas", document.getElementById('BackPeakCanvas').getContext('2d'));
            initialize10x15ValanceCanvas(document.getElementById('BackValanceCanvas').getContext('2d'));
            initialize10x15WallCanvas(document.getElementById('BackWallCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("RightPeakCanvas", document.getElementById('RightPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('RightValanceCanvas').getContext('2d'));
            initialize10x10WallCanvas(document.getElementById('RightWallCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("LeftPeakCanvas", document.getElementById('LeftPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('LeftValanceCanvas').getContext('2d'));
            initialize10x10WallCanvas(document.getElementById('LeftWallCanvas').getContext('2d'));

            document.getElementById('FrontPeakCanvas').style.marginLeft = '15px';
            document.getElementById('FrontValanceCanvas').style.marginLeft = '15px';
            document.getElementById('BackPeakCanvas').style.marginLeft = '15px';
            document.getElementById('BackValanceCanvas').style.marginLeft = '15px';
            document.getElementById('BackWallCanvas').style.marginLeft = '15px';
            document.getElementById('ValanceLogo').style.right = '10px';
            size = 15;
        }
        else{
            initialize10x10PeakCanvas("FrontPeakCanvas", document.getElementById('FrontPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('FrontValanceCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("BackPeakCanvas", document.getElementById('BackPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('BackValanceCanvas').getContext('2d'));
            initialize10x10WallCanvas(document.getElementById('BackWallCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("RightPeakCanvas", document.getElementById('RightPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('RightValanceCanvas').getContext('2d'));
            initialize10x10WallCanvas(document.getElementById('RightWallCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("LeftPeakCanvas", document.getElementById('LeftPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('LeftValanceCanvas').getContext('2d'));
            initialize10x10WallCanvas(document.getElementById('LeftWallCanvas').getContext('2d'));

            document.getElementById('FrontPeakCanvas').style.marginLeft = '90px';
            document.getElementById('FrontValanceCanvas').style.marginLeft = '90px';
            document.getElementById('BackPeakCanvas').style.marginLeft = '90px';
            document.getElementById('BackValanceCanvas').style.marginLeft = '90px';
            document.getElementById('BackWallCanvas').style.marginLeft = '90px';
            document.getElementById('ValanceLogo').style.right = '5px';
            size = 10;
        }
    }
    else{
        if(`${itDescript}`.includes('10x20')){
            initialize10x20PeakCanvas("FrontPeakCanvas", document.getElementById('FrontPeakCanvas').getContext('2d'));
            initialize10x20ValanceCanvas(document.getElementById('FrontValanceCanvas').getContext('2d'));
        
            initialize10x20PeakCanvas("BackPeakCanvas", document.getElementById('BackPeakCanvas').getContext('2d'));
            initialize10x20ValanceCanvas(document.getElementById('BackValanceCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("RightPeakCanvas", document.getElementById('RightPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('RightValanceCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("LeftPeakCanvas", document.getElementById('LeftPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('LeftValanceCanvas').getContext('2d'));

            document.getElementById('FrontPeakCanvas').style.marginLeft = '-60px';
            document.getElementById('FrontValanceCanvas').style.marginLeft = '-60px';
            document.getElementById('BackPeakCanvas').style.marginLeft = '-60px';
            document.getElementById('BackValanceCanvas').style.marginLeft = '-60px';
            document.getElementById('ValanceLogo').style.right = '5px';
            size = 20;
            
        }
        else if(`${itDescript}`.includes('10x15')){
            initialize10x15PeakCanvas("FrontPeakCanvas", document.getElementById('FrontPeakCanvas').getContext('2d'));
            initialize10x15ValanceCanvas(document.getElementById('FrontValanceCanvas').getContext('2d'));
        
            initialize10x15PeakCanvas("BackPeakCanvas", document.getElementById('BackPeakCanvas').getContext('2d'));
            initialize10x15ValanceCanvas(document.getElementById('BackValanceCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("RightPeakCanvas", document.getElementById('RightPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('RightValanceCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("LeftPeakCanvas", document.getElementById('LeftPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('LeftValanceCanvas').getContext('2d'));

            document.getElementById('FrontPeakCanvas').style.marginLeft = '15px';
            document.getElementById('FrontValanceCanvas').style.marginLeft = '15px';
            document.getElementById('BackPeakCanvas').style.marginLeft = '15px';
            document.getElementById('BackValanceCanvas').style.marginLeft = '15px';
            document.getElementById('ValanceLogo').style.right = '10px';
            size = 15;
        }
        else{
            initialize10x10PeakCanvas("FrontPeakCanvas", document.getElementById('FrontPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('FrontValanceCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("BackPeakCanvas", document.getElementById('BackPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('BackValanceCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("RightPeakCanvas", document.getElementById('RightPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('RightValanceCanvas').getContext('2d'));
        
            initialize10x10PeakCanvas("LeftPeakCanvas", document.getElementById('LeftPeakCanvas').getContext('2d'));
            initialize10x10ValanceCanvas(document.getElementById('LeftValanceCanvas').getContext('2d'));

            document.getElementById('FrontPeakCanvas').style.marginLeft = '90px';
            document.getElementById('FrontValanceCanvas').style.marginLeft = '90px';
            document.getElementById('BackPeakCanvas').style.marginLeft = '90px';
            document.getElementById('BackValanceCanvas').style.marginLeft = '90px';
            document.getElementById('ValanceLogo').style.right = '5px';
            size = 10;
        }
        hasWalls = false;
    }
}

function initialize10x20PeakCanvas(canvasId, context) {
    const tentScaleFactor1 = 0.225;
    const peakTopWidth1 = 372; // mm
    const peakBottomWidth1 = 755; // mm
    const peakHeight1 = 227; // mm
    const mmToPx = 3.7795275591;
    const peakTopWidthPx1 = peakTopWidth1 * mmToPx * tentScaleFactor1;
    const peakBottomWidthPx1 = peakBottomWidth1 * mmToPx * tentScaleFactor1;
    const peakHeightPx1 = peakHeight1 * mmToPx * tentScaleFactor1;
    context.canvas.width = peakBottomWidthPx1;
    context.canvas.height = peakHeightPx1;
    const peakControlOffset1 = -105;

    context.beginPath();
    context.moveTo((context.canvas.width - peakTopWidthPx1) / 2, 0);
    context.lineTo((context.canvas.width + peakTopWidthPx1) / 2, 0);
    context.quadraticCurveTo(context.canvas.width + peakControlOffset1, peakHeightPx1 / 2, context.canvas.width, peakHeightPx1);
    context.lineTo(0, peakHeightPx1);
    context.quadraticCurveTo(-peakControlOffset1, peakHeightPx1 / 2, (context.canvas.width - peakTopWidthPx1) / 2, 0);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor1;
    context.strokeStyle = "#5A5A5A";
    context.stroke();

    const overlayId = canvasId.replace('Canvas', 'TextOverlay');
    const overlay = document.getElementById(overlayId);

    const clipPath = `M ${(context.canvas.width - peakTopWidthPx1) / 2},0 L ${(context.canvas.width + peakTopWidthPx1) / 2},0 Q ${context.canvas.width + peakControlOffset1},${peakHeightPx1 / 2} ${context.canvas.width},${peakHeightPx1} L 0,${peakHeightPx1} Q ${-peakControlOffset1},${peakHeightPx1 / 2} ${(context.canvas.width - peakTopWidthPx1) / 2},0 Z`;
    
    overlay.style.clipPath = `path('${clipPath}')`;
}

function initialize10x20ValanceCanvas(context) {
    const tentScaleFactor1 = 0.225;
    const valanceHeight = 45;
    const mmToPx = 3.7795275591;
    const valanceHeightPx = valanceHeight * mmToPx * tentScaleFactor1;
    const peakBottomWidth1 = 755; // mm
    const peakBottomWidthPx1 = peakBottomWidth1 * mmToPx * tentScaleFactor1;
    context.canvas.width = peakBottomWidthPx1;
    context.canvas.height = valanceHeightPx;

    context.beginPath();
    context.rect(0, 0, context.canvas.width, context.canvas.height);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor1;
    context.strokeStyle = "#5A5A5A";
    context.stroke();
}

function initialize10x20WallCanvas(context) {
    const tentScaleFactor1 = 0.225;
    const wallHeight1 = 265; // mm
    const mmToPx = 3.7795275591;
    const wallHeightPx1 = wallHeight1 * mmToPx * tentScaleFactor1;
    const peakBottomWidth1 = 755; // mm
    const peakBottomWidthPx1 = peakBottomWidth1 * mmToPx * tentScaleFactor1;
    context.canvas.width = peakBottomWidthPx1;
    context.canvas.height = wallHeightPx1;

    context.beginPath();
    context.rect(0, 0, context.canvas.width, context.canvas.height);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor1;
    context.strokeStyle = "#5A5A5A";
    context.stroke();
}

function initialize10x10PeakCanvas(canvasId, context) {
    const tentScaleFactor2 = 0.225;
    const triangleWidth = 400; // mm
    const triangleHeight = 227; // mm
    const mmToPx = 3.7795275591;
    const triangleWidthPx = triangleWidth * mmToPx * tentScaleFactor2;
    const triangleHeightPx = triangleHeight * mmToPx * tentScaleFactor2;
    context.canvas.width = triangleWidthPx;
    context.canvas.height = triangleHeightPx;
    const controlOffset = 65;

    context.beginPath();
    context.moveTo(context.canvas.width / 2, 0);
    context.quadraticCurveTo(context.canvas.width / 2 + controlOffset, triangleHeightPx / 2, context.canvas.width, triangleHeightPx);
    context.lineTo(0, triangleHeightPx);
    context.quadraticCurveTo(context.canvas.width / 2 - controlOffset, triangleHeightPx / 2, context.canvas.width / 2, 0);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor2;
    context.strokeStyle = "#5A5A5A";
    context.stroke();

    const overlayId = canvasId.replace('Canvas', 'TextOverlay');
    const overlay = document.getElementById(overlayId);

    const clipPath = `M ${context.canvas.width / 2},0 Q ${context.canvas.width / 2 + controlOffset},${triangleHeightPx / 2} ${context.canvas.width},${triangleHeightPx} L 0,${triangleHeightPx} Q ${context.canvas.width / 2 - controlOffset},${triangleHeightPx / 2} ${context.canvas.width / 2},0 Z`;

    overlay.style.clipPath = `path('${clipPath}')`;
}

function initialize10x10ValanceCanvas(context) {
    const tentScaleFactor2 = 0.225;
    const valanceHeight = 45;
    const mmToPx = 3.7795275591;
    const valanceHeightPx = valanceHeight * mmToPx * tentScaleFactor2;
    const triangleWidth = 400; // mm
    const triangleWidthPx = triangleWidth * mmToPx * tentScaleFactor2;
    context.canvas.width = triangleWidthPx;
    context.canvas.height = valanceHeightPx;

    context.beginPath();
    context.rect(0, 0, context.canvas.width, context.canvas.height);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor2;
    context.strokeStyle = "#5A5A5A";
    context.stroke();
}

function initialize10x10WallCanvas(context) {
    const tentScaleFactor2 = 0.225;
    const wallHeight2 = 250; // mm
    const mmToPx = 3.7795275591;
    const wallHeightPx2 = wallHeight2 * mmToPx * tentScaleFactor2;
    const triangleWidth = 400; // mm
    const triangleWidthPx = triangleWidth * mmToPx * tentScaleFactor2;
    context.canvas.width = triangleWidthPx;
    context.canvas.height = wallHeightPx2;

    context.beginPath();
    context.rect(0, 0, context.canvas.width, context.canvas.height);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor2;
    context.strokeStyle = "#5A5A5A";
    context.stroke();
}

function initialize10x15PeakCanvas(canvasId, context) {
    const tentScaleFactor3 = 0.225;
    const peakTopWidth2 = 210; // mm
    const peakBottomWidth2 = 565; // mm
    const peakHeight2 = 227; // mm
    const mmToPx = 3.7795275591;
    const peakTopWidthPx2 = peakTopWidth2 * mmToPx * tentScaleFactor3;
    const peakBottomWidthPx2 = peakBottomWidth2 * mmToPx * tentScaleFactor3;
    const peakHeightPx2 = peakHeight2 * mmToPx * tentScaleFactor3;
    context.canvas.width = peakBottomWidthPx2;
    context.canvas.height = peakHeightPx2;
    const peakControlOffset3 = -100;

    context.beginPath();
    context.moveTo((context.canvas.width - peakTopWidthPx2) / 2, 0);
    context.lineTo((context.canvas.width + peakTopWidthPx2) / 2, 0);
    context.quadraticCurveTo(context.canvas.width + peakControlOffset3, peakHeightPx2 / 2, context.canvas.width, peakHeightPx2);
    context.lineTo(0, peakHeightPx2);
    context.quadraticCurveTo(-peakControlOffset3, peakHeightPx2 / 2, (context.canvas.width - peakTopWidthPx2) / 2, 0);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor3;
    context.strokeStyle = "#5A5A5A";
    context.stroke();

    const overlayId = canvasId.replace('Canvas', 'TextOverlay');
    const overlay = document.getElementById(overlayId);

    const clipPath = `M ${(context.canvas.width - peakTopWidthPx2) / 2},0 L ${(context.canvas.width + peakTopWidthPx2) / 2},0 Q ${context.canvas.width + peakControlOffset3},${peakHeightPx2 / 2} ${context.canvas.width},${peakHeightPx2} L 0,${peakHeightPx2} Q ${-peakControlOffset3},${peakHeightPx2 / 2} ${(context.canvas.width - peakTopWidthPx2) / 2},0 Z`;
    
    overlay.style.clipPath = `path('${clipPath}')`;
}


function initialize10x15ValanceCanvas(context) {
    const tentScaleFactor3 = 0.225;
    const valanceHeight = 45;
    const mmToPx = 3.7795275591;
    const valanceHeightPx3 = valanceHeight * mmToPx * tentScaleFactor3;
    const peakBottomWidth2 = 565; // mm
    const peakBottomWidthPx2 = peakBottomWidth2 * mmToPx * tentScaleFactor3;
    context.canvas.width = peakBottomWidthPx2;
    context.canvas.height = valanceHeightPx3;

    context.beginPath();
    context.rect(0, 0, context.canvas.width, context.canvas.height);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor3;
    context.strokeStyle = "#5A5A5A";
    context.stroke();
}

function initialize10x15WallCanvas(context) {
    const tentScaleFactor3 = 0.225;
    const wallHeight3 = 265; // mm
    const mmToPx = 3.7795275591;
    const wallHeightPx3 = wallHeight3 * mmToPx * tentScaleFactor3;
    const peakBottomWidth2 = 565; // mm
    const peakBottomWidthPx2 = peakBottomWidth2 * mmToPx * tentScaleFactor3;
    context.canvas.width = peakBottomWidthPx2;
    context.canvas.height = wallHeightPx3;

    context.beginPath();
    context.rect(0, 0, context.canvas.width, context.canvas.height);
    context.closePath();
    context.fillStyle = "white";
    context.fill();
    context.lineWidth = 1 * tentScaleFactor3;
    context.strokeStyle = "#5A5A5A";
    context.stroke();
}

function showCanvasWithOverlay(mainCanvasId, ...overlayCanvasIds) {
    const mainCanvas = document.getElementById(mainCanvasId);
    mainCanvas.style.display = 'block';

    overlayCanvasIds.forEach(canvasId => {
        const canvas = document.getElementById(canvasId);
        if (canvasId.includes('Text')){
            canvas.style.display = 'flex';
        }
        else{
            canvas.style.display = 'block';    
        }
        
    });
}

function updateOverlayPositionAndSize(sectionTitle) {
    const combinedOverlayId = `${sectionTitle.replace(' ', '')}TextOverlay`;
    const combinedOverlay = document.getElementById(combinedOverlayId);
    const tentCanvas = document.getElementById(`${sectionTitle.replace(' ', '')}Canvas`);

    if (!combinedOverlay || !tentCanvas) {
        console.error(`Overlay or canvas not found for section: ${sectionTitle}`);
        return;
    }

    // Update the combined overlay's position and size
    combinedOverlay.style.position = 'absolute';
    combinedOverlay.style.left = tentCanvas.offsetLeft + 'px';
    combinedOverlay.style.top = tentCanvas.offsetTop + 'px';
    combinedOverlay.style.width = tentCanvas.width + 'px';
    combinedOverlay.style.height = tentCanvas.height + 'px';
    combinedOverlay.style.display = 'flex';
    combinedOverlay.style.alignItems = 'center';
    combinedOverlay.style.justifyContent = 'center';
}

function toggleTentSettingsMenu() {
    const menu = document.getElementById('tent-settings-menu');
    menu.style.display = (menu.style.display === 'none' || menu.style.display === '') ? 'block' : 'none';
    updateTentPricing();
  }
  
  function saveTentSettings() {
    const size = getSelectedTentSize();
    const frame = document.querySelector('input[name="frame-type"]:checked').value;
    const walls = document.querySelector('input[name="walls-present"]:checked').value;
    const total = document.getElementById("total-price").innerText;
    
    itDescript = size;
    if(walls === 'yes'){
        itType = true;
    }else{
        itType = false;
    }

    document.getElementById("pricing").textContent = `Total Price: ${total}`;
    higherPrice = total;

    let inputValues = getSectionInputValues(sectionsConfig);
    const old1 = snapshotPickrs(pickrInstances);
    const old2 = snapshotPickrs(pickrInstances2);
    const old3 = snapshotPickrs(pickrInstances3);


    if(itType){
        sectionsConfig = [
            {
                id: 'section1',
                name:'1',
                title: 'Front Peak',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section2',
                name:'2',
                title: 'Front Valance',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section3',
                name:'3',
                title: 'Back Peak',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section4',
                name:'4',
                title: 'Back Valance',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section5',
                name:'5',
                title: 'Back Wall',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section6',
                name:'6',
                title: 'Right Peak',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section7',
                name:'7',
                title: 'Right Valance',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section8',
                name:'8',
                title: 'Right Wall',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section9',
                name:'9',
                title: 'Left Peak',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section10',
                name:'10',
                title: 'Left Valance',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section11',
                name:'11',
                title: 'Left Wall',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            }    
        ];
    }
    else{
        sectionsConfig = [
            {
                id: 'section1',
                name:'1',
                title: 'Front Peak',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section2',
                name:'2',
                title: 'Front Valance',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section3',
                name:'3',
                title: 'Back Peak',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section4',
                name:'4',
                title: 'Back Valance',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section5',
                name:'5',
                title: 'Right Peak',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section6',
                name:'6',
                title: 'Right Valance',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section8',
                name:'7',
                title: 'Left Peak',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },
            {
                id: 'section9',
                name:'8',
                title: 'Left Valance',
                colorOptions: ['White', 'Black', 'Silver', 'Grey', 'Vegas Gold', 'Maroon', 'Cardinal', 'Red', 'Orange', 'Yellow Gold', 'Yellow', 'Kelly Green', 'Forest Green', 'Navy Blue', 'Royal Blue', 'Columbia Blue', 'Purple']
            },  
        ];
    }
    currentSection = 1;
    totalSections = sectionsConfig.length;
    generateSections(sectionsConfig);
    showSection(currentSection);
    initializeAllCanvases();
    restorePickrs(pickrInstances, old1);
    restorePickrs(pickrInstances2, old2);
    restorePickrs(pickrInstances3, old3);
    applySectionInputValues(inputValues, sectionsConfig);
    bindSectionEventListeners();
  
    var title;
    const topOnly = document.querySelector('input[name="frame-type"]:checked').value === 'none';
    onlyTop = topOnly;
    if(topOnly){
        title = `${itDescript} Tent Top Only`;
    }
    else if(itType){
        title = `Custom ${itDescript} Tent Value Pack`;
    }
    else{
        title = `Fully Custom ${itDescript} Tent`;
    }
    document.getElementById("tentTitle").textContent = title;
    document.getElementById('tent-settings-menu').style.display = 'none';

    // let the DOM finish applying layout changes
    requestAnimationFrame(() => {
        const overlays = document.querySelectorAll('.text-overlay');
        overlays.forEach(overlay => overlay.style.display = 'none');
        buttonSwitchTab('tent-front');
    }); 
  }

function snapshotPickrs(pickrCollection) {
  const snapshot = {};
  Object.keys(pickrCollection).forEach(key => {
    const p = pickrCollection[key];
    if (p) {
      snapshot[key] = p.getColor().toHEXA().toString();
    }
    
  });
  return snapshot;
}

function restorePickrs(newPickrs, snapshot) {
  Object.keys(snapshot).forEach(key => {
    if (newPickrs[key]) {
      let color = snapshot[key];
      if (color && !color.startsWith('#')) {
        color = '#' + color; // ensure valid hex string
      }

      // Delay until Pickr is initialized
      newPickrs[key].on('init', instance => {
        instance.setColor(color, true); // false = update UI
      });
    }
  });
}


function applySectionInputValues(oldValues, newSections) {
    newSections.forEach(section => {
        const sectionId = section.id;
        const sectionTitle = section.title;
        const sectionName = section.name;

        const match = Object.values(oldValues).find(val => val.id === sectionTitle);
        if (!match) return;

        const overlayId = `${sectionTitle.replace(' ', '')}TextOverlay`;
        const targetOverlay = document.getElementById(overlayId);
        const targetCanvas = document.getElementById(`${sectionTitle.replace(' ', '')}Canvas`);

        // 1. Restore color
        const colorRadios = document.querySelectorAll(`input[name="color-${sectionId}"]`);
        const colorLabel = document.getElementById(`selected-color-${sectionId}`);
        let colorSet = false;

        colorRadios.forEach(radio => {
            if (radio.value === match.color) {
                radio.checked = true;
                colorSet = true;
            } else {
                radio.checked = false;
            }
        });

        if (!colorSet && match.color) {
            const targetPickr = pickrInstances[sectionName];
            if (targetPickr) {
                targetPickr.setColor(match.color, false);
            }
            if (colorLabel) colorLabel.textContent = match.color;
        }

        updateSelectedColor(section, match.color, colorLabel);

        // 2. Restore text input
        const textInput = document.getElementById(`text-input-${sectionId}`);
        if (textInput) {
            textInput.value = match.text || '';
        }

        // 3. Restore font style
        if (match.fontStyle) {
            selectDropdownOption(`font-style-${sectionId}`, match.fontStyle, sectionId);
        } else {
            const fontButton = document.querySelector(`#font-style-${sectionId}`)?.parentElement.querySelector('.custom-dropdown-button');
            if (fontButton) {
                fontButton.setAttribute('value', '');
                fontButton.innerHTML = `Select a Font Style <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>`;
            }
        }

        // 4. Restore font color
        if (match.fontColor) {
            const targetPickr2 = pickrInstances2[sectionName];
            if (targetPickr2) {
                targetPickr2.setColor(match.fontColor, false);
            }
            selectColorPickerOption(`font-color-${sectionId}`, match.fontColor, sectionId);
        }

        // 5. Restore outline color
        if (match.outlineColor && match.outlineColor.toLowerCase() !== 'none') {
            const targetPickr3 = pickrInstances3[sectionName];
            if (targetPickr3) {
                targetPickr3.setColor(match.outlineColor, false);
            }
            selectColorPickerOption(`outline-color-${sectionId}`, match.outlineColor, sectionId);
        } else {
            const targetPickr3 = pickrInstances3[sectionName];
            if (targetPickr3) {
                targetPickr3.setColor(null, false);
            }
            selectColorPickerOption(`outline-color-${sectionId}`, null, sectionId);
        }

        // 6. Restore notes
        const notesInput = document.getElementById(`notes-${sectionId}`);
        if (notesInput) {
            notesInput.value = match.notes || '';
        }

        // Only rebuild/restore if there was an actual text element saved before
        if (match.textState) {
            // 7. Rebuild text element through current system
            updateCanvasText(section);
            validateTextInput(sectionId);

            // 8. Restore text box state
            const textElement = document.getElementById(`editable-text-${sectionId}`);
            if (textElement) {
                textElement.style.width = match.textState.width || textElement.style.width;
                textElement.style.height = match.textState.height || textElement.style.height;
                textElement.style.fontSize = match.textState.fontSize || textElement.style.fontSize;

                if (match.textState.paddingTop) textElement.style.paddingTop = match.textState.paddingTop;
                if (match.textState.paddingRight) textElement.style.paddingRight = match.textState.paddingRight;
                if (match.textState.paddingBottom) textElement.style.paddingBottom = match.textState.paddingBottom;
                if (match.textState.paddingLeft) textElement.style.paddingLeft = match.textState.paddingLeft;

                const rotation = match.textState.rotation || '0';
                textElement.dataset.rotation = rotation;
                textElement.style.transform = `rotate(${rotation}deg)`;

                const textContent = textElement.querySelector('.text-content');
                if (textContent) {
                    textContent.innerText = match.textState.content || match.text || '';
                }
                adjustTextboxSize(textElement, textContent);
                restoreRelativeTextPosition(textElement, match.textState, targetOverlay);
            }
        }

        // 9. Restore preview art HTML
        const newArtDiv = document.getElementById(`art-preview-${sectionId}`);
        if (newArtDiv) {
            newArtDiv.innerHTML = '';
        }

        // 10. Clear existing overlay art
        if (targetOverlay) {
            targetOverlay.querySelectorAll('.editable-art').forEach(el => el.remove());
        }

        // 11. Restore art preview cards and overlay art from saved state
        if (Array.isArray(match.artElements) && match.artElements.length > 0) {
            match.artElements.forEach((artState) => {
                const newArtId = `image-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

                // Preview card
                if (newArtDiv) {
                    const previewElement = `
                        <div class="art-container" id="${newArtId}-preview" style="position: relative; display: inline-block; margin: 5px;" draggable="true" ondragstart="onDragStart(event)" ondragover="onDragOver(event)" ondragleave="onDragLeave(event)" ondrop="onDrop(event)" ondragend="onDragEnd(event)">
                            <img src="${artState.src}" alt="Art Preview" style="max-width: 115px; height: auto;">
                            <button class="remove-art" onclick="removeArt('${newArtId}')">&times;</button>
                            <div class="custom-dropdown2">
                                <button type="button" id="selected-image-size-${newArtId}" class="custom-dropdown-button" onclick="toggleDropdown('image-size-${newArtId}')">
                                    Choose Size
                                    <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                                    </svg>
                                </button>
                                <div class="custom-dropdown-content" id="image-size-${newArtId}">
                                    <div onclick="selectImageSizeOption('${newArtId}', 'valance-3-4', '3/4 Valance Image')">3/4 Valance Image</div>
                                    <div onclick="selectImageSizeOption('${newArtId}', 'valance-full', 'Full Valance Image')">Full Valance Image</div>
                                    <div onclick="selectImageSizeOption('${newArtId}', 'peak-partial', 'Partial Peak Image')">Partial Peak Image</div>
                                    <div onclick="selectImageSizeOption('${newArtId}', 'peak-full', 'Full Peak Image')">Full Peak Image</div>
                                    <div onclick="selectImageSizeOption('${newArtId}', 'wall', 'Wall Image')">Wall Image</div>
                                </div>
                            </div>
                        </div>`;
                    newArtDiv.insertAdjacentHTML('beforeend', previewElement);
                }

                // Overlay art
                if (targetOverlay) {
                    const artEl = document.createElement('div');
                    artEl.id = newArtId;
                    artEl.setAttribute('data-id', newArtId);
                    artEl.className = 'editable-art';
                    artEl.style.position = 'absolute';
                    artEl.style.cursor = 'move';
                    artEl.style.transformOrigin = 'center center';
                    artEl.style.width = artState.width;
                    artEl.style.height = artState.height;

                    const rotation = artState.rotation || '0';
                    artEl.dataset.rotation = rotation;
                    artEl.style.transform = `rotate(${rotation}deg)`;

                    artEl.innerHTML = `
                        <img src="${artState.src}" draggable="false" />
                        <div class="dot top-left"></div>
                        <div class="dot top-right"></div>
                        <div class="dot bottom-left"></div>
                        <div class="dot bottom-right"></div>
                        <div class="dot rotate"></div>
                        <div class="rotate-handle"></div>
                    `;

                    const imgEl = artEl.querySelector('img');
                    imgEl.style.width = '100%';
                    imgEl.style.height = '100%';
                    imgEl.style.display = 'block';
                    imgEl.style.pointerEvents = 'none';
                    imgEl.style.userSelect = 'none';

                    targetOverlay.appendChild(artEl);

                    console.log(artEl.style.top, artEl.style.left);

                    restoreRelativeArtLayout(artEl, artState, targetOverlay);

                    console.log(artEl.style.top, artEl.style.left);

                    makeElementDraggable(artEl, targetOverlay);
                    makeArtResizable(artEl);
                    makeElementRotatable(artEl);
                }
            });
        }

        addSelectionListener(targetOverlay);

        // 12. Show/hide art label
        const artOrderLabel = document.getElementById(`art-order-label-${sectionId}`);
        if (artOrderLabel) {
            artOrderLabel.style.display = newArtDiv && newArtDiv.children.length > 0 ? 'block' : 'none';
        }
    });
}

function restoreRelativeTextPosition(textElement, textState, overlay) {
    if (!textElement || !textState || !overlay) return;

    const relX = parseFloat(textState.relativeCenterX);
    const relY = parseFloat(textState.relativeCenterY);

    if (!isNaN(relX) && !isNaN(relY)) {
        const newCenterX = relX * overlay.offsetWidth;
        const newCenterY = relY * overlay.offsetHeight;

        textElement.style.left = `${newCenterX - (textElement.offsetWidth / 2)}px`;
        textElement.style.top = `${newCenterY - (textElement.offsetHeight / 2)}px`;
        return;
    }

    // fallback for older saved data
    if (textState.left) textElement.style.left = textState.left;
    if (textState.top) textElement.style.top = textState.top;
}

function restoreRelativeArtLayout(artElement, artState, overlay) {
    if (!artElement || !artState || !overlay) return;

    const relX = parseFloat(artState.relativeCenterX);
    const relY = parseFloat(artState.relativeCenterY);

    let overlayWidth;
    if(itDescript.includes('20')){
        overlayWidth = 642;
    }
    else if(itDescript.includes('15')){
        overlayWidth = 480;
    }
    else{
        overlayWidth = 340;
    }

    if (!isNaN(relX) && !isNaN(relY)) {
        const newCenterX = relX * overlayWidth;
        const newCenterY = relY * 193;

        const savedWidth = parseFloat(artState.width) || artElement.offsetWidth;
        const savedHeight = parseFloat(artState.height) || artElement.offsetHeight;

        artElement.style.left = `${newCenterX - (savedWidth / 2)}px`;
        artElement.style.top = `${newCenterY - (savedHeight / 2)}px`;
        return;
    }

    if (artState.left) artElement.style.left = artState.left;
    if (artState.top) artElement.style.top = artState.top;
}
function updateSelectedColor(section, color, selectedColorSpan) {
    const sectionDiv = document.getElementById(section.id);
    const selectedRadio = sectionDiv.querySelector('.color-radio:checked');
    const textInput = document.getElementById(`text-input-${section.id}`);

    const colorClassMap = {
        'None': 'none',
        'White': 'rgb(255, 255, 255)',
        'Black': 'rgb(6, 8, 8)',
        'Silver': 'rgb(194, 194, 194)',
        'Grey': 'rgb(141, 140, 140)',
        'Vegas Gold': 'rgb(192, 196, 148)',
        'Maroon': 'rgb(85, 33, 50)',
        'Cardinal': 'rgb(134, 40, 56)',
        'Red': 'rgb(197, 44, 44)',
        'Orange': 'rgb(218, 75, 18)',
        'Yellow Gold': 'rgb(255, 189, 13)',
        'Yellow': 'rgb(252, 230, 13)',
        'Kelly Green': 'rgb(68, 177, 92)',
        'Forest Green': 'rgb(52, 78, 48)',
        'Navy Blue': 'rgb(27, 35, 75)',
        'Royal Blue': 'rgb(47, 95, 167)',
        'Columbia Blue': 'rgb(143, 169, 221)',
        'Purple': 'rgb(115, 81, 158)',
    };

    if (selectedRadio) {
        selectedColorSpan.textContent = selectedRadio.value;
        const canvas = document.getElementById(section.title.replace(' ', '') + 'Canvas');
        if (canvas) {
            const context = canvas.getContext('2d');
            context.fillStyle = colorClassMap[selectedRadio.value];
            context.fill();
            context.strokeStyle = '#5A5A5A';
            context.stroke();
            if (section.title === "Front Valance") {
                updateValanceLogo(selectedRadio.value);
            }
            if (textInput.value !== '') {
                updateCanvasText(section);
            }
        }
    }
    else{
        updateCanvasColor(color, section);
    }
}

function updateValanceLogo(color){
    const logo = document.getElementById('ValanceLogo');
    switch (color){
        // Black Logo is used
        case 'White':
        case 'Silver':
        case 'Vegas Gold':
        case 'Yellow Gold':
        case 'Yellow':
             logo.src = `${window.shopifyAssetPaths.logos.blackValance}`;
             break;

        // White Logo is used
        case 'Black':
        case 'Grey':
        case 'Maroon':
        case 'Cardinal':
        case 'Red':
        case 'Orange':
        case 'Forest Green':
        case 'Navy Blue':
        case 'Purple':
        case 'Royal Blue':
        case 'Kelly Green':
        case 'Columbia Blue':
            logo.src = `${window.shopifyAssetPaths.logos.whiteValance}`;
            break;
    }
    if(color.includes("#")){
        const rgb = hexToRgb(color);

        // Calculate brightness (perceived brightness)
        const brightness = Math.sqrt(
            0.299 * (rgb.r * rgb.r) +
            0.587 * (rgb.g * rgb.g) +
            0.114 * (rgb.b * rgb.b)
        );

        // Choose logo based on brightness
        if (brightness > 150) { // Adjust this threshold as needed
            logo.src = `${window.shopifyAssetPaths.logos.blackValance}`;
        } else {
            logo.src = `${window.shopifyAssetPaths.logos.whiteValance}`;
        }
    }
}

function updateCanvasColor(color, section) {
    const canvas = document.getElementById(section.title.replace(' ', '') + 'Canvas');
    const textInput = document.getElementById(`text-input-${section.id}`);
    if (canvas) {
        const context = canvas.getContext('2d');
        context.fillStyle = color;
        context.fill();
        context.strokeStyle = '#5A5A5A';
        context.stroke();
        if (section.title === "Front Valance") {
            updateValanceLogo(color);
        }
        if (textInput.value !== '') {
            updateCanvasText(section);
        }
    }

    // Uncheck radio buttons in the current section
    const allRadios = document.querySelectorAll('.color-radio');
    allRadios.forEach(radio => {
        if (radio.id.includes(currentSection) && currentSection == section.name) {
            radio.checked = false;
        }
    });
    
}

function getSectionInputValues(sectionsConfig) {
    const data = {};

    sectionsConfig.forEach(section => {
        const id = section.id;
        const overlayId = `${section.title.replace(' ', '')}TextOverlay`;
        const overlay = document.getElementById(overlayId);

        // 1. Color
        const radio = document.querySelector(`input[name="color-${id}"]:checked`);
        const customColor = document.getElementById(`selected-color-${id}`)?.textContent?.trim() || '';
        const selectedColor = radio ? radio.value : customColor;

        // 2. Text input
        const text = document.getElementById(`text-input-${id}`)?.value || '';

        // 3. Font style
        const fontButton = document.querySelector(`#font-style-${id}`)?.parentElement.querySelector('.custom-dropdown-button');
        const fontStyle = fontButton?.getAttribute('value') || '';

        // 4. Font color
        const fontColor = document.getElementById(`font-color-${id}`)?.textContent?.trim() || '';

        // 5. Outline color
        const outlineColor = document.getElementById(`outline-color-${id}`)?.textContent?.trim() || '';

        // 6. Notes
        const notes = document.getElementById(`notes-${id}`)?.value || '';

        // 7. Preview HTML backup
        const originalPreviewDiv = document.getElementById(`art-preview-${id}`);
        const oldArtPreviewDiv = originalPreviewDiv ? originalPreviewDiv.cloneNode(true) : null;

        // 8. Overlay art state
        const artElements = [];
        if (overlay) {
            overlay.querySelectorAll('.editable-art').forEach((artEl) => {
                const img = artEl.querySelector('img');

                const left = parseFloat(artEl.style.left || 0);
                const top = parseFloat(artEl.style.top || 0);
                const width = artEl.offsetWidth;
                const height = artEl.offsetHeight;
                const overlayWidth = overlay.offsetWidth;
                const overlayHeight = overlay.offsetHeight;

                artElements.push({
                    id: artEl.getAttribute('data-id') || artEl.id || '',
                    src: img?.src || '',
                    left: artEl.style.left || '0px',
                    top: artEl.style.top || '0px',
                    width: artEl.style.width || `${width}px`,
                    height: artEl.style.height || `${height}px`,
                    rotation: artEl.dataset.rotation || '0',

                    relativeCenterX: overlayWidth ? ((left + (width / 2)) / overlayWidth) : 0.5,
                    relativeCenterY: overlayHeight ? ((top + (height / 2)) / overlayHeight) : 0.5
                });
            });
        }

        // 9. Text box state
        const textElement = document.getElementById(`editable-text-${id}`);
        let textState = null;

        if (textElement && overlay) {
            const textContent = textElement.querySelector('.text-content');

            const left = parseFloat(textElement.style.left || 0);
            const top = parseFloat(textElement.style.top || 0);
            const width = textElement.offsetWidth;
            const height = textElement.offsetHeight;
            const overlayWidth = overlay.offsetWidth;
            const overlayHeight = overlay.offsetHeight;

            textState = {
                left: textElement.style.left || '0px',
                top: textElement.style.top || '0px',
                width: textElement.style.width || `${width}px`,
                height: textElement.style.height || `${height}px`,
                fontSize: textElement.style.fontSize || window.getComputedStyle(textElement).fontSize,
                rotation: textElement.dataset.rotation || '0',
                paddingTop: textElement.style.paddingTop || window.getComputedStyle(textElement).paddingTop,
                paddingRight: textElement.style.paddingRight || window.getComputedStyle(textElement).paddingRight,
                paddingBottom: textElement.style.paddingBottom || window.getComputedStyle(textElement).paddingBottom,
                paddingLeft: textElement.style.paddingLeft || window.getComputedStyle(textElement).paddingLeft,
                content: textContent ? textContent.innerText.replace(/\r/g, '') : text,
                relativeCenterX: overlayWidth ? ((left + (width / 2)) / overlayWidth) : 0.5,
                relativeCenterY: overlayHeight ? ((top + (height / 2)) / overlayHeight) : 0.5
            };
        }

        data[section.name] = {
            id: section.title,
            color: selectedColor,
            text,
            fontStyle,
            fontColor,
            outlineColor,
            notes,
            oldArtPreviewDiv,
            artElements,
            textState
        };
    });

    return data;
}

  
  function getSelectedTentSize() {
    const selected = document.querySelector('input[name="tent-size"]:checked');
    return selected ? selected.value : null;
  }
  
  function updateFramePricing() {
    const selectedFrame = document.querySelector('input[name="frame-type"]:checked').value;
    const aluminumLabel = document.getElementById('frame-aluminum-label');
    const topOnlyLabel = document.getElementById('frame-top-only-label');

    const wallsYesRadio = document.querySelector('input[name="walls-present"][value="yes"]');
    const wallsNoRadio = document.querySelector('input[name="walls-present"][value="no"]');
    const wallsGroup = document.querySelector('.settings-group.walls-group');

    if (selectedFrame === 'none') {
        aluminumLabel.innerText = 'Aluminum (+$100.00)';
        topOnlyLabel.innerText = 'Top Only';

        if (wallsYesRadio) wallsYesRadio.checked = false;
        if (wallsNoRadio) wallsNoRadio.checked = true;

        if (wallsYesRadio) wallsYesRadio.disabled = true;
        if (wallsNoRadio) wallsNoRadio.disabled = true;

        if (wallsGroup) wallsGroup.style.opacity = '0.5';
    } else {
        aluminumLabel.innerText = 'Aluminum';
        topOnlyLabel.innerText = `Top Only ${formatPriceDiff(topPrices[getSelectedTentSize()] - tentPrices[getSelectedTentSize()])}`;

        if (wallsYesRadio) wallsYesRadio.disabled = false;
        if (wallsNoRadio) wallsNoRadio.disabled = false;

        if (wallsGroup) wallsGroup.style.opacity = '1';
    }

    updateTentPricing();
  }

  function updateTentPricing() {
    const selectedSize = document.querySelector('input[name="tent-size"]:checked').value;
    const selectedFrame = document.querySelector('input[name="frame-type"]:checked').value;
    const hasWalls = document.querySelector('input[name="walls-present"]:checked').value === 'yes';
    const topOnly = document.querySelector('input[name="frame-type"]:checked').value === 'none';
  
    let basePrice;
    const wallCost = hasWalls ? wallUpcharge[selectedSize] : 0;
    const frameCost =  0;
  
    // Update Tent Size Labels
    if(!topOnly){
        basePrice = tentPrices[selectedSize];
        for (const size in tentPrices) {
            const label = document.getElementById(`price-${size}`);
            if (!label) continue;
        
            const labelText = `${size.replace('x', "'x")}'`; // e.g., 10x10 => 10'x10'
            if (size === selectedSize) {
            label.textContent = `${labelText}`;
            } else {
            const diff = tentPrices[size] - tentPrices[selectedSize];
            label.textContent = `${labelText} ${formatPriceDiff(diff)}`;
            }
        }
    }
    else{
        basePrice = topPrices[selectedSize];
        for (const size in topPrices) {
            const label = document.getElementById(`price-${size}`);
            if (!label) continue;
        
            const labelText = `${size.replace('x', "'x")}'`; // e.g., 10x10 => 10'x10'
            if (size === selectedSize) {
            label.textContent = `${labelText}`;
            } else {
            const diff = topPrices[size] - topPrices[selectedSize];
            label.textContent = `${labelText} ${formatPriceDiff(diff)}`;
            }
        }
    }
      
  
    // Update Walls Label
    const yesLabel = document.getElementById('wall-yes-label');
    const noLabel = document.getElementById('wall-no-label');
    const diff = wallUpcharge[selectedSize];
  
    if (hasWalls) {
      yesLabel.textContent = "Yes";
      noLabel.textContent = `No ${formatPriceDiff(-diff)}`;
      //itType = true;
    } else {
      noLabel.textContent = "No";
      yesLabel.textContent = `Yes ${formatPriceDiff(diff)}`;
      //itType = false;
    }

    const aluminumLabel = document.getElementById('frame-aluminum-label');
    const topOnlyLabel = document.getElementById('frame-top-only-label');

    if (selectedFrame === 'none') {
        aluminumLabel.innerText = `Aluminum ${formatPriceDiff(tentPrices[getSelectedTentSize()] - topPrices[getSelectedTentSize()])}`;
        topOnlyLabel.innerText = 'Top Only';
    } else {
        aluminumLabel.innerText = 'Aluminum';
        topOnlyLabel.innerText = `Top Only ${formatPriceDiff(topPrices[getSelectedTentSize()] - tentPrices[getSelectedTentSize()])}`;
    }

  
    // Update Total
    const total = basePrice + wallCost + frameCost;
    document.getElementById('total-price').textContent = `$${total.toFixed(2)}`;
  }
  
  function formatPriceDiff(diff) {
    if (diff === 0) return '';
    const sign = diff > 0 ? '+' : '–';
    return `(${sign}$${Math.abs(diff).toFixed(2)})`;
  }
  
  
  const tentPrices = {
    "10x10": 1000.00,
    "10x15": 1200.00,
    "10x20": 1500.00
  };
  const wallUpcharge = {
    "10x10": 300.00,
    "10x15": 500.00,
    "10x20": 600.00
  };

  const topPrices = {
    "10x10": 600.00,
    "10x15": 750.00,
    "10x20": 825.00
  }
  
  